import React, { useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect, useSelector } from 'react-redux';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import {
  makeSelectKeycloakToken,
  makeSelectListings,
} from 'containers/AppContainer/selectors';
import {
  makeSelecClaimRecap,
  makeSelectCorporealLawyers,
} from 'containers/RecapManagerPage/selectors';
import * as util from 'containers/RecapManagerPage/utils';
import {
  requestClaimRecap,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import { requestSagisClaimInfo } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import { makeSelectSagisClaim } from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import LawyerRecap from 'containers/LawyerRecapPage/LawyerRecap';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { get } from 'lodash';
import { LISTINGS } from 'containers/data-structure';
import { makeSelecClaimToPreopen } from 'containers/PreOpeningPage/selectors';
import {
  requestUpdateClaim,
  setClaim,
} from 'containers/PreOpeningPage/actions';
import {
  resetUploadDocumentStore,
  setDocumentId,
  uploadDocument,
  requestGetReportsPolicy,
} from 'containers/UploadDocuments/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import { ClaimRecapType } from 'typings/claimTypes';

export interface LawyerRecapPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  claimId: string;
  requestClaimRecap: Function;
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  corporealLawyers: any;
  setClaim: Function;
  requestUpdateClaim: Function;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  setDocumentId: Function;
  documentId: string;
  requestSagisClaimInfo: Function;
  sagisInfo: any;
  keyloackToken: any;
  resetStoreClaim: Function;
  requestGetReportsPolicy: Function;
  requestGetDocByDocumentumId: Function;
}

const LawyerRecapPage: React.FC<LawyerRecapPageProps> = (
  props,
): JSX.Element => {
  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
    };
  }, []);
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  const uploadedDocument = useSelector(makeSelectDocument());

  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings, props.keyloackToken]);
  return (
    <LawyerRecap
      listings={props.listings}
      storedClaimToPreopen={props.storedClaimToPreopen}
      requestClaimRecap={props.requestClaimRecap}
      claimRecap={props.claimRecap}
      policyInfo={props.policyInfo}
      requestSearchClaims={props.requestSearchClaims}
      resetSearchClaimsStore={props.resetSearchClaimsStore}
      claimId={props.match.params.claimId}
      shouldDisplayBreadCrumbs
      className="globalBloc"
      stakeholders={stakeholders}
      setClaimRecap={props.setClaim}
      requestUpdateClaim={props.requestUpdateClaim}
      uploadDocument={props.uploadDocument}
      uploadedDocument={uploadedDocument}
      resetUploadedDocument={props.resetUploadDocumentStore}
      setDocumentId={props.setDocumentId}
      documentId={props.documentId}
      requestSagisClaimInfo={props.requestSagisClaimInfo}
      sagisInfo={props.sagisInfo}
      keycloakToken={props.keyloackToken}
      requestGetReportsPolicy={props.requestGetReportsPolicy}
      requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
    />
  );
};

const mapDispatchToProps = {
  requestClaimRecap,
  requestSearchClaims,
  resetSearchClaimsStore,
  setClaim,
  requestUpdateClaim,
  resetUploadDocumentStore,
  uploadDocument,
  setDocumentId,
  requestSagisClaimInfo,
  resetStoreClaim,
  requestGetReportsPolicy,
  requestGetDocByDocumentumId,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  corporealLawyers: makeSelectCorporealLawyers(),
  storedClaimToPreopen: makeSelecClaimToPreopen(),
  documentId: makeSelectDocumentId(),
  sagisInfo: makeSelectSagisClaim(),
  keyloackToken: makeSelectKeycloakToken(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LawyerRecapPage));
